import { useEffect } from 'react';
import { sendYandexEvent } from 'common/utils/index';
import { useUser } from 'store/features/auth/selectors/user';
import { EMPTY_STRING } from 'common/constants';

const useSendYandexEvents = () => {
  const { clientCode = EMPTY_STRING, userType = EMPTY_STRING } =
    useUser() || {};

  useEffect(() => {
    if (clientCode) {
      sendYandexEvent('setUserID', clientCode);
      sendYandexEvent('userParams', { userType });
    }
  }, [clientCode, userType]);
};

export default useSendYandexEvents;
